export const STATEMENT_STATUSES = {
  requested: 'Requested',
  underReview: 'UnderReview',
  confirmed: 'Confirmed',
};
